export default __webpack_public_path__ + "static/seroja-roof-repairs-b0380719743b956fa9591318d0500f02.jpg";